/**
 * El mapa entre vistas y rutas con path real.
 *
 * Las vistas vivian en `?vista=meta`: para Google eso son variantes de UNA
 * pagina, y un buscador no puede posicionar lo que no tiene URL propia. Con
 * paths de verdad (/meta, /mazos, /carta/ID) cada seccion es una pagina
 * indexable con su titulo y su descripcion, que el servidor inyecta al servir.
 *
 * Los nombres van en español porque el publico busca en español: /mazos dice
 * mas en una pagina de resultados que /decks. El unico mapa vive aqui y lo
 * comparten App (leer y escribir la URL) y Nav (los href de las pestañas).
 */
/*
 * El META es la portada: es lo jugoso del sitio y a lo que debe llegar quien
 * entra por la puerta. La enciclopedia, que antes vivia en `/`, se muda a
 * /cartas. El servidor acompaña con un 301 de /meta a `/` para no perder lo ya
 * indexado.
 */
export const RUTA_DE_VISTA = {
  meta: '/',
  cards: '/cartas',
  decks: '/mazos',
  matches: '/partidas',
  admin: '/admin',
};

const VISTA_DE_RUTA = {
  ...Object.fromEntries(
    Object.entries(RUTA_DE_VISTA).map(([vista, ruta]) => [ruta, vista])
  ),
  // La ruta vieja del meta sigue entendiendose: enlaces guardados y entradas
  // de historial anteriores al cambio llegan por aqui (el servidor ya
  // redirige, pero el cliente no debe depender de ello para navegar).
  '/meta': 'meta',
};

/** /carta/swsh3-136 -> "swsh3-136"; cualquier otra ruta -> null. */
export function cartaDeRuta(pathname) {
  const m = pathname.match(/^\/carta\/([^/]+)\/?$/);
  return m ? decodeURIComponent(m[1]) : null;
}

/** Vista que corresponde a un pathname; una carta pertenece a la enciclopedia. */
export function vistaDeRuta(pathname) {
  if (cartaDeRuta(pathname)) return 'cards';
  // Ruta desconocida -> la portada, que ahora es el meta.
  return VISTA_DE_RUTA[pathname.replace(/\/+$/, '') || '/'] ?? 'meta';
}

/** Pathname que corresponde al estado: la carta abierta manda sobre la vista. */
export function rutaDeEstado(view, cartaAbierta) {
  if (cartaAbierta) return `/carta/${encodeURIComponent(cartaAbierta)}`;
  return RUTA_DE_VISTA[view] ?? '/';
}
